import { render, staticRenderFns } from "./dynamicHeader.vue?vue&type=template&id=2128d950&scoped=true&"
import script from "./dynamicHeader.vue?vue&type=script&lang=js&"
export * from "./dynamicHeader.vue?vue&type=script&lang=js&"
import style0 from "./dynamicHeader.vue?vue&type=style&index=0&id=2128d950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2128d950",
  null
  
)

export default component.exports